export default __webpack_public_path__ + "static/media/english-to-turkish-screenshot-05.a760c812.png";